export class RoleManagmentToken {
  static IRoleManagementRepository = Symbol("IRoleManagementRepository");
  static RoleManagementUseCase = Symbol("RoleManagementUseCase");
  static RoleManagementViewModel = Symbol("RoleManagementViewModel");
}
